module.exports = __webpack_public_path__ + "onboarding4.png";